// extracted by mini-css-extract-plugin
module.exports = {"root":"ClearentDisclaimer_root__3lKkc","header":"ClearentDisclaimer_header__1wUZ_","inner":"ClearentDisclaimer_inner__3linj"};